import React, { useState } from 'react';
import { XIcon, ShieldCheckIcon } from 'lucide-react';
type ModalType = 'politicas' | 'terminos' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-6 px-4 bg-deep-black border-t border-card-border mb-16" data-id="element-76">
        <div className="max-w-4xl mx-auto text-center" data-id="element-77">
          <p className="font-inter text-sm text-text-muted mb-6" data-id="element-78">
            © {new Date().getFullYear()} El Protocolo de Blindaje — Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-79">
            <button onClick={() => setActiveModal('politicas')} className="font-inter text-sm text-text-muted hover:text-cyan-neon transition-colors underline underline-offset-4" data-id="element-80">
              Política de Reembolso
            </button>
            <span className="text-card-border" data-id="element-81">|</span>
            <button onClick={() => setActiveModal('terminos')} className="font-inter text-sm text-text-muted hover:text-cyan-neon transition-colors underline underline-offset-4" data-id="element-82">
              Términos y Condiciones
            </button>
          </div>
          <p className="font-inter text-xs text-text-muted/50 mt-6" data-id="element-83">
            Este producto es distribuido y procesado de forma segura por
            Hotmart.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-84">
          <div className="bg-card-dark border border-card-border rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-85">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-text-muted hover:text-white transition-colors" aria-label="Cerrar" data-id="element-86">
              <XIcon className="w-6 h-6" data-id="element-87" />
            </button>

            {activeModal === 'politicas' && <div className="space-y-6" data-id="element-88">
                <div className="flex items-center gap-3 mb-2" data-id="element-89">
                  <ShieldCheckIcon className="w-8 h-8 text-cyan-neon" data-id="element-90" />
                  <h2 className="font-bebas text-3xl text-white tracking-wide" data-id="element-91">
                    POLÍTICA DE REEMBOLSO
                  </h2>
                </div>

                <div className="font-inter text-text-muted space-y-4 text-sm leading-relaxed" data-id="element-92">
                  <div className="bg-cyan-neon/10 border border-cyan-neon/30 rounded-lg p-4" data-id="element-93">
                    <p className="text-cyan-neon font-semibold text-base mb-1" data-id="element-94">
                      🛡️ Garantía de Hierro — 7 Días
                    </p>
                    <p data-id="element-95">
                      Tienes{' '}
                      <strong className="text-white" data-id="element-96">7 días naturales</strong> a
                      partir de la fecha de compra para solicitar un reembolso
                      completo del 100% de tu inversión. Sin preguntas, sin
                      complicaciones.
                    </p>
                  </div>

                  <p data-id="element-97">
                    <strong className="text-white" data-id="element-98">
                      ¿Cómo solicitar tu reembolso?
                    </strong>
                    <br data-id="element-99" />
                    Simplemente envía un correo electrónico o solicita el
                    reembolso directamente a través de la plataforma Hotmart
                    dentro de los primeros 7 días desde tu compra. El proceso es
                    automático y recibirás tu dinero de vuelta en un plazo de 5
                    a 10 días hábiles según tu método de pago.
                  </p>

                  <p data-id="element-100">
                    <strong className="text-white" data-id="element-101">Condiciones:</strong>
                  </p>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-102">
                    <li data-id="element-103">
                      El reembolso debe solicitarse dentro de los{' '}
                      <strong className="text-white" data-id="element-104">7 días naturales</strong>{' '}
                      posteriores a la compra.
                    </li>
                    <li data-id="element-105">
                      Pasados los 7 días, no se aceptarán solicitudes de
                      reembolso bajo ninguna circunstancia.
                    </li>
                    <li data-id="element-106">
                      El reembolso aplica para todos los planes disponibles
                      (Esencial, PRO y Soberanía Total).
                    </li>
                    <li data-id="element-107">
                      El procesamiento del reembolso es gestionado por Hotmart
                      de forma segura.
                    </li>
                  </ul>

                  <p className="text-white font-semibold" data-id="element-108">
                    El riesgo es nuestro. Si no funciona para ti, recuperas tu
                    dinero. Así de simple.
                  </p>
                </div>
              </div>}

            {activeModal === 'terminos' && <div className="space-y-6" data-id="element-109">
                <h2 className="font-bebas text-3xl text-white tracking-wide" data-id="element-110">
                  TÉRMINOS Y CONDICIONES
                </h2>

                <div className="font-inter text-text-muted space-y-4 text-sm leading-relaxed" data-id="element-111">
                  <p data-id="element-112">
                    <strong className="text-white" data-id="element-113">1. Producto Digital</strong>
                    <br data-id="element-114" />
                    "El Protocolo de Blindaje" es un producto digital
                    informativo y educativo. Al realizar la compra, recibirás
                    acceso inmediato al contenido digital correspondiente a tu
                    plan seleccionado a través de la plataforma Hotmart.
                  </p>

                  <p data-id="element-115">
                    <strong className="text-white" data-id="element-116">2. Uso Personal</strong>
                    <br data-id="element-117" />
                    El contenido adquirido es para uso personal y exclusivo del
                    comprador. Queda estrictamente prohibida la reproducción,
                    distribución, reventa o compartición del material con
                    terceros.
                  </p>

                  <p data-id="element-118">
                    <strong className="text-white" data-id="element-119">
                      3. Garantía de 7 Días
                    </strong>
                    <br data-id="element-120" />
                    Ofrecemos una garantía de reembolso de{' '}
                    <strong className="text-white" data-id="element-121">7 días naturales</strong> a
                    partir de la fecha de compra. Si por cualquier motivo no
                    estás satisfecho, puedes solicitar la devolución completa de
                    tu dinero dentro de ese período. Consulta nuestra Política
                    de Reembolso para más detalles.
                  </p>

                  <p data-id="element-122">
                    <strong className="text-white" data-id="element-123">4. Resultados</strong>
                    <br data-id="element-124" />
                    Los resultados pueden variar de persona a persona. Este
                    producto proporciona herramientas y protocolos basados en
                    principios de neurociencia conductual, pero no garantiza
                    resultados específicos. El compromiso y la aplicación del
                    usuario son factores determinantes.
                  </p>

                  <p data-id="element-125">
                    <strong className="text-white" data-id="element-126">
                      5. Descargo de Responsabilidad
                    </strong>
                    <br data-id="element-127" />
                    Este producto no sustituye asesoramiento médico, psicológico
                    o profesional. Si experimentas problemas de salud mental, te
                    recomendamos consultar con un profesional calificado.
                  </p>

                  <p data-id="element-128">
                    <strong className="text-white" data-id="element-129">
                      6. Plataforma de Pago
                    </strong>
                    <br data-id="element-130" />
                    Todas las transacciones son procesadas de forma segura por
                    Hotmart. Al realizar la compra, aceptas también los términos
                    de servicio de dicha plataforma.
                  </p>

                  <p data-id="element-131">
                    <strong className="text-white" data-id="element-132">7. Modificaciones</strong>
                    <br data-id="element-133" />
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Las modificaciones no afectarán compras
                    ya realizadas.
                  </p>
                </div>
              </div>}
          </div>
        </div>}
    </>;
}